import {
    REQUEST_PROVIDERS,
    RECEIVE_PROVIDERS,
    DISPLAY_PROVIDER_DIALOG,
    CLOSE_PROVIDER_DIALOG
} from '../actions/authenticationActions';

export default function providerDialogReducer(state = {}, action) {
    switch (action.type) {
        case REQUEST_PROVIDERS:
            return { ...state, reqStartTime: action.startTime };
        case RECEIVE_PROVIDERS:
            return {
                ...state,
                providers: action.providers,
                reqCompleteTime: action.completeTime
            };
        case DISPLAY_PROVIDER_DIALOG:
            return { ...state, display: true };
        case CLOSE_PROVIDER_DIALOG:
            return { ...state, display: false };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./app/common/reducers/providerDialogReducer.js